import { logger } from '@pkg/logger';

interface StaticMapOptions {
  coordinates: string;
  zoom?: string | number;
  size?: string;
  marker?: string;
  style?: string;
}

let cachedApiKey: string | null = null;

export function useStaticMapUrl() {
  const getApiKey = async(): Promise<string | null> => {
    if (cachedApiKey) {
      return cachedApiKey;
    }

    try {
      const { apiKey } = await $fetch<{ apiKey: string }>('/api/google-maps-api-key');
      if (apiKey) {
        cachedApiKey = apiKey;
        return apiKey;
      }
    } catch (error) {
      logger.info('Failed to fetch Google Maps API key', error);
    }

    return null;
  };

  const getStaticMapUrl = async(options: StaticMapOptions): Promise<string | null> => {
    if (!options.coordinates) {
      logger.error('Coordinates are required for static map');
      return null;
    }

    const marketingApiKey = await getApiKey();
    if (!marketingApiKey) {
      logger.warn('Google Marketing API key is not configured');
      return null;
    }

    const coordinates = String(options.coordinates);
    const zoom = String(options.zoom || '9');
    const size = String(options.size || '350x120');
    const marker = String(options.marker || '');
    const style = String(options.style || '');

    return `https://maps.googleapis.com/maps/api/staticmap?center=${coordinates}&zoom=${zoom}&size=${size}&${marker}&${style}&key=${marketingApiKey}`;
  };

  return {
    getStaticMapUrl,
  };
}
